var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4361 24.8671C15.8153 24.8612 10.4265 22.6257 6.45135 18.6511C2.47624 14.6764 0.241188 9.28747 0.235352 3.66632C0.235352 2.7291 0.607837 1.83044 1.27022 1.16768C1.93292 0.505289 2.83163 0.132812 3.76886 0.132812H7.30237C8.2396 0.132812 9.13826 0.505297 9.8007 1.16768C10.4634 1.83038 10.8359 2.7291 10.8359 3.66632V9.69966L6.86093 13.6746H6.86062C8.09575 15.464 9.64825 17.0118 11.441 18.2417L15.4159 14.2668L21.436 14.2665C22.3733 14.2665 23.2719 14.639 23.9347 15.3017C24.5971 15.964 24.9695 16.8627 24.9695 17.8V21.3335C24.9695 22.2707 24.5971 23.1694 23.9347 23.8321C23.272 24.4945 22.3733 24.867 21.436 24.867L21.4361 24.8671ZM14.6784 20.0084C16.8215 20.8917 19.1183 21.3418 21.4361 21.3336V17.8H16.8693L14.6784 20.0084ZM3.76894 3.66632C3.76062 5.98411 4.21075 8.28092 5.09406 10.424L7.30245 8.21561V3.66632H3.76894Z",
    fill: "#001A27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.80f57d93d0c9284752c3e86f0ff92bb3.svg";
export { ForwardRef as ReactComponent };